const getProductMargin = (price, originalPrice) => {
  const rawMargin = (price - originalPrice) / price;
  const formattedMargin =
    (rawMargin >= 0 ? "+" : "") + (rawMargin * 100).toFixed(2);
  return formattedMargin;
};

export default getProductMargin;
